import { useSyncExternalStore } from "react";
import { subscribeAuthChanges, getActiveContext, hasPermission } from "@envirohub/utils";

function getContextSnapshot() {
  return getActiveContext();
}

/**
 * React hook that re-renders whenever auth state changes and returns
 * the current customer context with permission helpers.
 */
export function useCustomerContext() {
  const context = useSyncExternalStore(
    subscribeAuthChanges,
    getContextSnapshot,
    getContextSnapshot,
  );

  const scope = context?.scope ?? null;
  const isB2B = scope === "CUSTOMER_B2B";
  const isB2C = scope === "CUSTOMER_B2C";
  const permissions = context?.permissions ?? [];

  return {
    context,
    scope,
    isB2B,
    isB2C,
    canManageRequests: isB2C || !isB2B || hasPermission("customer.requests.manage", permissions),
    canManageLocations: isB2C || !isB2B || hasPermission("customer.locations.manage", permissions),
    canReadWallet: isB2C || hasPermission("org.wallet.read", permissions),
    canTopUpWallet: isB2C || hasPermission("org.wallet.topup", permissions),
    canManageSpendingLimits: isB2B && hasPermission("org.wallet.limits.manage", permissions),
    canManageOrgRoles: isB2B && hasPermission("org.roles.manage", permissions),
  };
}
